<template>
<!-- 填写发票记录 -->
    <div>
        <el-form
                ref="invoiceForm"
                :rules="invoiceFormRules"
                :model="invoiceForm"
                label-width="140px"

              >
                <el-row>
                  <el-col span="12">
                      <el-form-item label="合同名称" >
                        <div style="display:flex">
                            <el-input v-model="invoiceForm.name" disabled></el-input>
                            <el-button type="primary" size="small" @click="addConstract" v-show="operateStatus">选择合同</el-button>
                        </div>

                    </el-form-item>


                  </el-col>
                 <el-col span="12">
                      <el-form-item label="合同编号" >
                        <el-input v-model="invoiceForm.code" disabled></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="供应商名称" prop="partnerName">
                      <el-input :disabled="true" v-model="invoiceForm.partnerName" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="税号" prop="taxNo">
                      <el-input :disabled="true" v-model="invoiceForm.taxNo"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="发票类型" prop="type">
                      <el-select
                        class="el-select-wide"
                        v-model="invoiceForm.type"
                        placeholder="请选择"
                        :disabled="!operateStatus"
                      >
                        <el-option
                          v-for="(item, index) in dictData.invoiceType"
                          :key="index"
                          :label="item.dictValue"
                          :value="item.dictKey"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票金额" prop="amount" style="text-align: right;">
                      
                       <moneyInput v-model="invoiceForm.amount" placeholder="请输入发票金额" :disabled="!operateStatus" template="append" style="width: 100%"  />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="税率" prop="taxRate">
                      <el-select
                        class="el-select-wide"
                        v-model="invoiceForm.taxRate"
                        placeholder="请选择"
                        :disabled="!operateStatus"
                      >
                        <el-option
                          v-for="(item, index) in dictData.taxRateList"
                          :key="index"
                          :label="item.dictValue"
                          :value="item.dictKey"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票内容" prop="content">
                      <el-input :disabled="!operateStatus" v-model="invoiceForm.content"   maxlength="200"
                        show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="发票号码" prop="invoiceNo">
                      <el-input :disabled="!operateStatus" v-model="invoiceForm.invoiceNo"   maxlength="50"
                        show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票日期" prop="invoiceTime">
                      <el-date-picker
                      :disabled="!operateStatus"
                        v-model="invoiceForm.invoiceTime"
                        type="date"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        placeholder="选择日期"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="24">
                    <el-form-item label="备注" prop="remark">
                      <el-input
                      :disabled="!operateStatus"
                        type="textarea"
                        maxlength="200"
                        show-word-limit
                        rows="4"
                        v-model="invoiceForm.remark"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="附件" prop="attachList">
                  <VUpload :fileList="invoiceForm.attachList" :disabled="!operateStatus"/>
                </el-form-item>
                <el-form-item style="text-align:right" v-if="operateStatus">
                  <el-button type="primary" @click="handleSaveInvoice" style="margin-right: 20px"
                    >确定</el-button
                  >
                  <el-button @click="closeInvoice">取消</el-button>
                </el-form-item>
              </el-form>
            <el-dialog
                title="选择合同"
                :visible.sync="dialogVisible"
                v-if="dialogVisible"
                width="70%"
                append-to-body="true"
                :before-close="handleClose"
                :close-on-click-modal="false">
             <!-- :projectId="form.projectId" -->
             <choiceContract :projectId='projectId'   @getConstract="getConstract"></choiceContract>
             </el-dialog>

    </div>
</template>

<script>
import {
  getDictData,

  getBisDictData,
} from '@/api/crmedical/contract/add';
import choiceContract from '@/components/choiceContract/choiceContract';
import { vString } from '@/util/validate';
import VUpload from '@/views/components/v-upload.vue';
export default {
  components: { VUpload,choiceContract},
  props:{
      projectId:{
          default:'',
          type:String
      },
      operateStatus:{
        default:true,
        type:Boolean
      },
      invoiceForm:{}
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入小数点前9位后2位小数的金额'));
      }
    };
    return {
        dialogVisible:false,
      form: {},

      // 字典
      dictData: {
        invoiceType: [], //发票类型字典
        paymentTypeList: [], //付款类型字典
        taxRateList: [], //税率字典
        contractLifecycle: [], //合同生命周期(状态)
      },
      invoiceFormRules: {
        amount: [{ required: true, validator: validatePass, trigger: 'blur' }],
        content: {
          required: true,
          validator: vString('发票内容', 1, 200),
          trigger: 'change',
        },
        invoiceNo: [
          {
            required: true,
            validator: vString('发票号码', 1, 200),
            trigger: 'change',
          },
        ],
        taxRate: [{ required: true, message: '请选择税率', trigger: 'change' }],
        type: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        invoiceTime: [{ required: true, message: '请选择日期', trigger: 'change' }],

      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    closeInvoice(){
      this.$emit('close')
    },
    handleSaveInvoice(){
      this.$refs['invoiceForm'].validate((valid) => {
          if (valid) {
          //  this.form.payTime = this.dayjs(this.form.payTime).format('YYYY-MM-DD')
             this.$emit('getInvoiceDetail',this.invoiceForm)
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
    initData() {
      // 获取项目税率字典
      getBisDictData({
        code: 'project_contract_invoice_tax_rate',
        projectId: this.projectId,
      }).then((res) => {
        console.log('res getBisDictData==>', res);
        this.dictData.taxRateList = res.data;
      });
       // 发票类型字典
        getDictData({ code: 'invoice_type' }).then((res) => {

        this.dictData.invoiceType = res.data;
        });
    },
    addConstract(){
        this.dialogVisible = true
        // this.invoiceForm = {}
    },
    //获得合同给的信息
    getConstract(val){
          this.dialogVisible = false
        //   this.form = val
        this.invoiceForm.name = val.name
        this.invoiceForm.code = val.code
        this.invoiceForm.partnerName = val.partnerName
        this.invoiceForm.contractId = val.id
        this.invoiceForm.taxNo = val.taxNo
      },
  },
};
</script>

<style scoped>
::v-deep .el-col-12 {
  height: 54px;
}
</style>
